import { atom } from 'jotai';
import _merge from 'lodash/merge';
import _uniq from 'lodash/uniq';
const $EnterABTestInner = atom({ versions: '', parameters: {} });
// set once
export const $EnterABTest = atom((get) => get($EnterABTestInner), (get, set, value) => {
    const old = get($EnterABTestInner);
    if (!('versions' in old)) {
        set($EnterABTestInner, value);
    }
});
$EnterABTest.debugLabel = '$EnterABTest';
export const $CurrentABTest = atom({
    versions: '',
    parameters: {},
});
$CurrentABTest.debugLabel = '$CurrentABTest';
export const $ABTest = atom((get) => {
    const enterAbTest = get($EnterABTest);
    const currentAbTest = get($CurrentABTest);
    return {
        versions: _uniq([...enterAbTest.versions.split(','), ...currentAbTest.versions.split(',')]).join(','),
        parameters: _merge(enterAbTest.parameters, currentAbTest.parameters),
    };
});
$ABTest.debugLabel = '$ABTest';
